import { api } from "@/lib/api";

// Migración de cartera · etiquetas y utilidades compartidas por la página y los avisos del cliente.
export const ESTADO_LOTE = {
  validado: { label: "Validado", tono: "slate" },
  en_proceso: { label: "En proceso", tono: "amber" },
  terminado: { label: "Terminado", tono: "green" },
  terminado_con_errores: { label: "Terminado con errores", tono: "amber" },
  detenido_sin_cupo: { label: "Detenido sin consultas", tono: "red" },
  interrumpido: { label: "Interrumpido", tono: "red" },
};

export const TONO = {
  slate: "border-slate-200 bg-slate-50 text-slate-700",
  amber: "border-amber-200 bg-amber-50 text-amber-800",
  green: "border-emerald-200 bg-emerald-50 text-emerald-800",
  red: "border-red-200 bg-red-50 text-red-700",
};

export const ESTADOS_CONTINUAR = ["interrumpido", "detenido_sin_cupo"];

export const consultasTxt = (n) => (n == null ? "—" : n < 0 ? "Sin límite" : Number(n).toLocaleString("es-MX"));

export const fechaCorta = (iso) => {
  if (!iso) return "—";
  // Fecha sin hora (AAAA-MM-DD): se muestra tal cual, sin pasar por la zona horaria del navegador.
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso).slice(0, 10)
    : d.toLocaleDateString("es-MX", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export async function descargarArchivo(url, nombre) {
  const r = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}
